













/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleAbstract"
	})
export default class ArticleAbstract extends Vue {
	@Prop() private abstract: string;
	private changed(event: any) {
		this.$emit("update:abstract", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}
}
